import { HERO_PHOTOS } from '@/mocks/home';
import Bubbles from './Bubbles';

const STATS = [
  { value: '45+', label: 'Years Serving SWFL' },
  { value: '120+', label: 'Local Staff Members' },
  { value: '3x', label: 'Longer Client Retention' },
];

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-gradient-to-b from-secondary-100 via-background-50 to-background-50">
      <Bubbles />
      <div className="relative mx-auto max-w-[1280px] px-4 pb-16 pt-14 md:px-6 md:pb-24 md:pt-20">
        <div className="mx-auto max-w-4xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-secondary-300 bg-background-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-secondary-800">
            <i className="ri-sparkling-2-line text-accent-600"></i>
            Commercial &amp; Residential Cleaning · Fort Myers, Naples &amp; SWFL
          </span>
          <h1 className="mt-6 font-heading text-3xl font-extrabold leading-tight text-primary-800 md:text-5xl lg:text-[56px]">
            For Over 45 Years We&apos;ve Provided Consistent, Caring &amp; Compassionate Cleaning
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
            We&apos;re Crystal Clean — a family-owned commercial and residential cleaning company with over{' '}
            <strong className="font-semibold text-primary-700">120 local staff members</strong> and growing. We create
            clean, healthy and welcoming spaces across Southwest Florida.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#quote"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
            >
              <i className="ri-file-text-line text-[18px]"></i> Request A Free Quote
            </a>
            <a
              href="#services"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-7 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50 sm:w-auto"
            >
              Explore Our Services <i className="ri-arrow-right-line text-[18px]"></i>
            </a>
          </div>
        </div>

        {/* Circular photo strip */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4 md:mt-16 md:gap-6">
          {HERO_PHOTOS.map((p, i) => (
            <div
              key={p.alt}
              className={`animate-fade-up relative h-24 w-24 overflow-hidden rounded-full border-4 border-background-50 bg-secondary-200 md:h-36 md:w-36 ${
                i % 2 === 1 ? 'md:mb-8' : 'md:mt-8'
              }`}
              style={{ animationDelay: `${i * 0.12}s` }}
            >
              <img src={p.src} alt={p.alt} title={`${p.alt} — Crystal Clean Fort Myers`} className="h-full w-full object-cover object-top" />
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3 md:mt-16">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200 bg-background-50/80 px-6 py-6 text-center backdrop-blur-sm"
            >
              <p className="font-heading text-3xl font-extrabold text-accent-600 md:text-4xl">{s.value}</p>
              <p className="mt-1 text-sm font-medium text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}